import React from 'react'

function News() {
    return (
        <>
            <section className="newslater-area p-relative pt-120 pb-120" style={{ background: "#f7f5f1" }}>
                {/* <div className="animations-01"><img src="assets/img/bg/an-img-07.png" alt="contact-bg-an-05" /></div> */}
                <div className="container">
                    <div className="row justify-content-center align-items-center text-center">
                        <div className="col-xl-9 col-lg-9">
                            <div className="section-title center-align mb-40 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".3as">
                                {/* <h2>
                                Hotel La Finca por Zotoluca
                                </h2> */}
                                <h1>"A través de nuestra conexión con la Hacienda Zotoluca y la riqueza de la altiplanicie
pulquera, queremos posicionarnos como un destino único que redefine la hospitalidad en
Hidalgo&quot;</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default News